import BaseContextMenu from './BaseContextMenu';
import Button from '@components/Button';
import Input from '@components/Input';
import styles from './inputNameContextMenu.module.scss';
import React from 'react';
import useModalActions from '@hooks/common/useModalAction';
interface Props {
  title: string;
  initialValue?: string;
  onSave: (value: string) => void;
  onClose: () => void;
}

const InputNameContextMenu: React.FC<Props> = ({
  title,
  initialValue = '',
  onSave,
  onClose,
}) => {
  const [inputValue, setInputValue] = React.useState(initialValue);
  const { errorDefaultAction } = useModalActions();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //영어만 숫자만 인식하도록 설정. 한글 입력 시 바로 제거
    const sanitizedValue = e.target.value.replace(
      /[^a-zA-Z0-9\u1100-\u11FF\u3130-\u318F\uAC00-\uD7A3]/g,
      '',
    );
    setInputValue(sanitizedValue);
  };

  const handleSave = () => {
    if (inputValue.trim() === '') {
      errorDefaultAction('Please enter a value.');
      return;
    }
    onSave(inputValue);
    onClose();
  };

  return (
    <BaseContextMenu onClose={onClose} additionalClassName={styles.test}>
      <div className={styles.mainframe}>
        <div className={styles.title}>
          <div className={styles.titlelabel}>
            <div className={styles.titlelabel2}>
              <span className={styles.titlelabel3}>{title}</span>
            </div>
          </div>
        </div>
        <div className={styles.functionframe}>
          <div className={styles.inputWrapper}>
            <div className={styles.title}>
              <div className={styles.titlelabel}>
                <div className={styles.titlelabel2}>
                  <span className={styles.titlelabel3}>Name</span>
                </div>
              </div>
            </div>
            <div className={styles.input}>
              <input
                className={styles.item}
                type="text"
                value={inputValue}
                onChange={handleChange}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
              ></input>
            </div>
            {/* <Input
              className={styles.input}
              type="text"
              value={inputValue}
              onChange={handleChange}
            /> */}
          </div>

          <div className={styles.buttonGroup}>
            <div className={styles.buttonarea}>
              <div className={styles.buttonarea2}>
                <Button className={styles.button} onClick={onClose}>
                  Cancel
                </Button>
                <Button className={styles.buttonprimary} onClick={handleSave}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseContextMenu>
  );
};

export default InputNameContextMenu;
